<!--文章详情左侧用户目录组件-->
<template>
  <div class="content-wrap" :class="{'mobile-content-wrap': show_right_menu}">
    <div class="contextmenu" v-if="contextmenu_show" ref="contextmenu"
         :style="{top: contextmenu_y + 'px', left: contextmenu_x + 'px'}" v-clickoutside="hide">
      <!-- 文件夹上的右键菜单 -->
      <ul v-if="contextmenu_type == 'dir'">
        <li>
          <el-button type="text" class="contextmenu-btn" @click="contextmenu_show=false;dialog_create_new=true;">新建
          </el-button>
        </li>
      </ul>

      <!-- 文件上的右键菜单 -->
      <ul v-if="contextmenu_type == 'file'">
        <li>
          <el-button type="text" @click="modifyArticle" class="contextmenu-btn">编辑</el-button>
        </li>
        <li>
          <el-button type="text" @click="showRenameModal" class="contextmenu-btn">重命名</el-button>
        </li>
        <li>
          <el-button type="text" @click="confirmDeleteArticle" class="contextmenu-btn">删除</el-button>
        </li>
      </ul>
    </div>
    <div class="tools-icon-wrap">
      <div class="other-icon-wrap">
        <img
          v-if="showTree"
          class="tools-icon"
          @click="switchStructType('tree')"
          src="~assets/img/tree-active.png"
          alt=""
        >
        <img
          v-else
          class="tools-icon"
          @click="switchStructType('tree')"
          src="~assets/img/tree.png"
          alt=""
        >

        <img
          v-if="sortType === 'desc'"
          class="tools-icon"
          @click="switchStructType('flat', 'desc-active')"
          src="~assets/img/desc.png"
          alt=""
        >
        <img
          v-if="showFlat && sortType === 'desc-active'"
          class="tools-icon"
          @click="switchStructType('flat', 'desc-active')"
          src="~assets/img/desc-active.png"
          alt=""
        >
        <img
          v-if="sortType === 'asc'"
          class="tools-icon"
          @click="switchStructType('flat', 'asc-active')"
          src="~assets/img/asc.png"
          alt=""
        >
        <img
          v-if="showFlat && sortType === 'asc-active'"
          class="tools-icon"
          @click="switchStructType('flat', 'asc-active')"
          src="~assets/img/asc-active.png"
          alt=""
        >

      </div>
      <div class="sync-wrap" v-if="editable">
        <span
          @click.stop="onSyncRepo"
          title="同步外部更新"
          class="ion-android-refresh"
          style="cursor: pointer; padding: 10px 0 10px 10px">
       </span>
      </div>
    </div>
    <div class="el-tree-wrap">
      <el-tree
        v-show="showTree"
        :data="treeData"
        :props="defaultProps"
        default-expand-all
        :expand-on-click-node="false"
        node-key="id"
        ref="el_tree"
        icon-class="custom-tree-icon"
        empty-text=""
        @node-click="handleNodeClick"
        @node-contextmenu="nodeContextmenu"
        :draggable="editable"
        :allow-drop="allowDrop"
        @node-drop="handleDrop"
      >
        <nuxt-link
          v-if="data.type === 'file'"
          class="custom-tree-node pointer"
          slot-scope="{ node, data }"
          v-mouse-m-s="{ className: 'hover-btn-wrap', disabled: !editable }"
          :to="`/book/${$route.params.uid}/${data.id}`"
          :class="{dir: data.type === 'dir', file: data.type === 'file'}"
        >
          <i
            :class="{dir: data.type === 'dir', file: data.type === 'file', 'dir-off': !node.expanded,'file-on': article_id === node.data.id && data.type === 'file' }"></i>
          <span class="custom-tree-node_label-wrap">
        <span>{{ node.label }}</span>
      </span>
          <div
            v-if="editable && data.type === 'file'"
            class="hover-btn-wrap"
            style="display: none;"
            @click.prevent.stop=""
          >
          <span class="hover-btn theme-color" @click.prevent.stop="hoverEdit(data)">
            <i class="iconfont theme-color iconiconfonttubiao_bianji"></i>
            <span>编辑</span>
          </span>
            <span class="hover-btn theme-color" @click.prevent.stop="hoverRename(data, node)">
            <i class="iconfont   theme-color iconzhongmingming"></i>
            <span>重命名</span>
          </span>
            <span class="hover-btn theme-color" @click.prevent.stop="hoverDelete(data, node)">
            <i class="iconfont theme-color iconiconfonttubiao_shanchu"></i>
            <span>删除</span>
          </span>
          </div>
        </nuxt-link>
        <div
          v-else
          class="custom-tree-node pointer"
          v-mouse-m-s="{ className: 'hover-btn-wrap', disabled: !editable }"
          slot-scope="{ node, data }"
          :class="{dir: data.type === 'dir', file: data.type === 'file'}"
        >
          <i
            :class="{dir: data.type === 'dir', file: data.type === 'file', 'dir-off': !node.expanded,'file-on': article_id === node.data.id && data.type === 'file' }"></i>
          <span class="custom-tree-node_label-wrap">
          <span>{{ node.label }}</span>
        </span>
          <span
            v-if="editable && data.type === 'dir'"
            class="hover-btn-wrap"
            style="display: none;"
            @click.stop=""
          >
          <button class="hover-btn theme-color" @click.stop="hoverCreate(data)">
            <i class="iconfont theme-color iconxinzeng"></i> 新建
          </button>
        </span>
        </div>
      </el-tree>
      <div class="struct-flat-wrap" v-if="showFlat">
        <div class="struct-flat-item"
             v-for="item in transformFlatData"
             :key="item.id"
             v-mouse-m-s="{ className: 'hover-btn-wrap', disabled: !editable }"
        >
          <nuxt-link
            class="file-icon-title-wrap"
            :to="`/book/${$route.params.uid}/${item.id}`"
          >
            <i :class="{ file: item.type === 'file','file-on': article_id === item.id && item.type === 'file' }"></i>
            <span class="struct-flat-item_label-wrap">{{item.name}}</span>
          </nuxt-link>
          <div
            v-if="editable && item.type === 'file'"
            class="hover-btn-wrap"
            style="display: none;"
          >
            <span class="hover-btn theme-color" @click="hoverEdit(item)">
              <i class="iconfont theme-color iconiconfonttubiao_bianji"></i>
              编辑
            </span>
            <span class="hover-btn theme-color" @click="hoverRename(item, node)">
              <i class="iconfont theme-color iconzhongmingming"></i>
              重命名
            </span>
            <span class="hover-btn theme-color" @click="hoverDelete(item, node)">
              <i class="iconfont theme-color iconiconfonttubiao_shanchu"></i>
              删除
            </span>
          </div>
        </div>
      </div>

    </div>

    <!-- 重命名文章弹框 -->
    <el-dialog
      :visible="dialog_rename_visible"
      @close="dialogClose"
      title="重命名文章"
      width="400px"
      :append-to-body="true"
      @opened="handleOpenDialog"
      @closed="handleCloseDialog"
    >
      <el-form
        :model="renameForm"
        label-position="right"
        class="creat-new-form"
        label-width="80px"
        :rules="renameRules"
        ref="renameForm"
        @keydown.native.enter.prevent="handleRenameArticle"
      >
        <el-form-item label="旧名称：">
          <el-input size="small" class="modal-input" disabled v-model="renameForm.name"></el-input>
        </el-form-item>
        <el-form-item label="新名称：" prop="new_file_name">
          <el-input size="small" class="modal-input" ref="new_file_name" v-model="renameForm.new_file_name"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="rename-row" style="justify-content: flex-end;">
            <el-button size="middle" class="submit-btn" @click="handleRenameArticle">保存</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 新建文章弹框 -->
    <el-dialog
      :visible="dialog_create_new"
      @close="dialogCreateClose"
      title="新建" width="400px"
      :append-to-body="true"
      @opened="handleOpenDialog"
      @closed="handleCloseDialog"
    >
      <el-form
        :model="create_new_info"
        label-position="right"
        :rules="createRules"
        class="creat-new-form"
        label-width="100px"
        ref="createInfoForm"
        @keydown.native.enter.prevent="handleCreate"
      >
        <el-form-item label="目录名称：" prop="dir_name">
          <el-input size="small" class="modal-input" v-model="create_new_info.dir_name"></el-input>
        </el-form-item>
        <el-form-item label="笔记名称：" prop="article_name">
          <el-input size="small" class="modal-input" v-model="create_new_info.article_name"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="rename-row" style="justify-content: flex-end;">
            <el-button size="middle" class="submit-btn" @click="handleCreate">保存</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>

</template>

<script>
  import Vue from 'vue';
  import { mapState } from 'vuex';
  import Clickoutside from '~/utils/dom/clickoutside';
  import { deleteArticle, renameArticle, createArticle2, renameDir } from '../utils/api';
  import { errorMsg, successMsg, focus1stError, getFileName, getDirName } from '../utils/tools';
  import { SUCCESS } from '../utils/status-code';

  const STRUCT = {
    TREE: 'tree', // 树形结构
    FLAT: 'flat', // 扁平结构
  };
  const SORT_TYPE_MAP = {
    DESC: 'desc',
    ASC: 'asc',
    ASC_ACTIVE: 'asc-active',
    DESC_ACTIVE: 'desc-active',
  };
  const noInputSpaces = {
    validator: (rule, val, cb) => {
      if (val && !(val.trim())) {
        cb(new Error('请不要只输入空格'));
      } else {
        cb();
      }
    },
    trigger: 'change',
  };
  export default {
    name: 'tree',
    props: {
      treeData: Array,
      editable: Boolean,
      show_right_menu: Boolean,
      dir: String,
      flatData: {
        type: Array,
        default: () => ([]),
      },
    },
    data() {
      return {
        defaultProps: {
          children: 'child',
          label: 'name'
        },
        contextmenu_show: false,
        contextmenu_x: 0,
        contextmenu_y: 0,
        contextmenu_type: '', // file or dir
        renameForm: {
          name: '',
          new_file_name: '' // 重命名时的新文件名称
        },
        current_node: {},
        dialog_rename_visible: false,
        dialog_create_new: false,
        // 创建新的文章
        create_new_info: {
          dir_name: '',
          article_name: ''
        },
        contextMenuData: {},
        article_id: '',
        showStruct: STRUCT.TREE,
        sortType: SORT_TYPE_MAP.DESC,
        renameRules: {
          name: [
            {
              required: true,
              trigger: 'change'
            },
          ],
          new_file_name: [
            {
              required: true,
              message: '请输入新名称',
              trigger: 'change'
            },
            noInputSpaces,
            {
              validator: (rule, val, cb) => {
                if (val === this.renameForm.name) {
                  cb(new Error('新名称不能和旧名称相同'));
                } else {
                  cb();
                }
              },
              trigger: 'change',
            },
          ],
        },
        createRules: {
          dir_name: [
            noInputSpaces,
          ],
          article_name: [
            {
              required: true,
              message: '请输入笔记名称',
              trigger: 'change'
            },
            noInputSpaces,
            {
              validator: (rule, val, cb) => {
                if (val) {
                  const splitName = val.split('/');
                  const len = splitName.length;
                  if (len > 1) {
                    const realName = splitName[len - 1].trim();
                    if (!realName) {
                      cb(new Error('笔记名称不能为空'));
                    } else {
                      cb();
                    }
                  } else {
                    cb();
                  }
                } else {
                  cb();
                }
              },
              trigger: 'blur',
            },
          ],
        }
      };
    },
    computed: {
      ...mapState('auth', [
        'userInfo',
      ]),
      showTree() {
        return this.showStruct === STRUCT.TREE;
      },
      showFlat() {
        return this.showStruct === STRUCT.FLAT;
      },
      transformFlatData() {
        let cloneData = JSON.parse(JSON.stringify(this.flatData));
        if (this.sortType === SORT_TYPE_MAP.DESC_ACTIVE) {
          cloneData.sort((a, b) => (parseInt(a.mtime, 10) - parseInt(b.mtime, 10)));
        } else if (this.sortType === SORT_TYPE_MAP.ASC_ACTIVE) {
          cloneData.sort((a, b) => (parseInt(b.mtime, 10) - parseInt(a.mtime, 10)));
        }
        return cloneData;
      }
    },
    watch: {
      $route: {
        handler() {
          if (this.$route.params.detail) {
            this.article_id = this.$route.params.detail;
          }
        },
        immediate: true,
      }
    },
    created() {
      // let s = "";
      // this.data.forEach((item) => {
      //   s = item.name + ", " + item.type
      // });
      // console.log("dir:", this.dir, "data:", s);
    },
    mounted() {
      if (this.$route.params.detail) {
        this.article_id = this.$route.params.detail;
      }
    },
    methods: {
      handleNodeClick(data, node) {
        this.hide();
        const { id } = data;
        if (data.type === 'file') {
          this.$emit('handleFileClick', id);
        } else {
          node.expanded = !node.expanded;
        }
      },
      nodeContextmenu(event, data, node) {
        this.current_node = node;
        this.showContextMenu(event, data, data.type);
      },
      switchStructType(type, targetSortType) {
        // 点击工具图标时候的处理
        if (type === STRUCT.FLAT && targetSortType) {
          switch (targetSortType) {
            case SORT_TYPE_MAP.ASC: {
              this.sortType = this.showStruct === STRUCT.TREE ? SORT_TYPE_MAP.ASC : SORT_TYPE_MAP.ASC_ACTIVE;
              break;
            }
            case SORT_TYPE_MAP.ASC_ACTIVE : {
              this.sortType = SORT_TYPE_MAP.DESC_ACTIVE;
              break;
            }
            case SORT_TYPE_MAP.DESC: {
              this.sortType = this.showStruct === STRUCT.TREE ? SORT_TYPE_MAP.DESC : SORT_TYPE_MAP.DESC_ACTIVE;
              break;
            }
            case SORT_TYPE_MAP.DESC_ACTIVE : {
              this.sortType = SORT_TYPE_MAP.ASC_ACTIVE;
              break;
            }
            default: {
              break;
            }
          }
        }
        if (type === STRUCT.TREE) {
          this.sortType = this.sortType.split('-')[0];
        }
        this.showStruct = type;
      },
      /**
       * hover 菜单点击编辑
       */
      hoverEdit(item) {
        this.contextMenuData = item;
        this.modifyArticle();
      },
      /**
       * hover 菜单点击新建
       */
      hoverCreate(item) {
        this.contextMenuData = item;
        this.dialog_create_new = true;
      },
      /**
       * hover 菜单点击重命名
       */
      hoverRename(item, node) {
        this.current_node = node ? node : this.current_node;
        this.contextMenuData = item;
        this.renameForm.name = item.name;
        this.contextmenu_show = false;
        this.dialog_rename_visible = true;
        this.$nextTick(x => {
          this.$refs.new_file_name.focus();
        });
      },
      /**
       * hover 菜单删除
       */
      hoverDelete(item, node) {
        this.current_node = node ? node : this.current_node;
        this.confirmDeleteArticle(item);
      },
      handleClick(index) {
        let item = this.data[index];
        item.show_child = !item.show_child;
        Vue.set(this.data, index, item);
      },
      /**
       * 第一次点击时，通过此事件获取到真正的数据ID.
       *
       * @param index
       */
      handleFileClick(index) {
        let item = this.data[index];
        let id = item.id;
        this.$emit('handleFileClick', id);
      },
      onSyncRepo() {
        this.$emit('onSyncRepo');
      },
      /**
       * 父组件收到 handleFileClick 事件后，调用当前处理程序，
       * 不再转换 id，而是直接返回.
       *
       * @param id
       */
      handleChildFileClick(id) {
        this.$emit('handleFileClick', id);
      },
      /**
       * 显示右键菜单
       */
      showContextMenu($event, item, type) {
        if (this.editable) {
          this.contextmenu_show = 'inline-block';
          this.contextmenu_x = $event.clientX;
          this.contextmenu_y = $event.clientY;
          this.contextmenu_type = type;
          this.contextMenuData = item;
          this.renameForm.name = item.name;
        }
      },
      /**
       * 隐藏右键菜单
       */
      hide() {
        this.contextmenu_show = false;
      },
      /**
       * 编辑文章
       */
      modifyArticle() {
        this.renameForm.name = this.contextMenuData.name;
        this.$router.push({
          name: 'editor-id',
          params: { id: this.contextMenuData.id }
        });
      },
      showRenameModal() {
        this.contextmenu_show = false;
        this.dialog_rename_visible = true;
        this.$nextTick((x) => {
          this.$refs.new_file_name.focus();
        });
        this.renameForm.name = this.contextMenuData.name;
      },
      /**
       * 弹框询问用户是否确定删除文档
       */
      confirmDeleteArticle(data) {
        this.$confirm('此操作将永久删除该文件，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          // 删除文档
          const curArticle = data.id ? data : this.contextMenuData;
          let aid = curArticle.id;
          deleteArticle(aid).then((res) => {
            successMsg('删除成功');
            this.removeNode(this.current_node, curArticle);
          });
        });
      },
      removeNode(node, data) {
        const parent = node.parent;
        const children = parent.data.child || parent.data;
        const index = children.findIndex(d => d.id === data.id);
        children.splice(index, 1);
      },
      /**
       * 弹窗关闭时，同时也将输入的内容清空
       */
      dialogClose() {
        this.dialog_rename_visible = false;
      },
      /**
       * 重命名文档
       */
      handleRenameArticle() {
        this.$refs.renameForm.validate((valid) => {
          if (!valid) {
            return focus1stError();
          }
          const newFileName = this.renameForm.new_file_name.trim();
          const defaultExtensions = '.md';
          const { path } = this.contextMenuData;
          // 相对路径拼接，后端负责 normalize
          const extensions = path.match(/\.\w+$/)[0] || defaultExtensions;
          const paths = path.split('/');
          paths.splice(paths.length - 1, 1, `${newFileName}${extensions}`);
          const new_path = paths.join('/');
          renameArticle(this.contextMenuData.id, path, new_path).then(res => {
            if (res.errno !== SUCCESS.code) {
              errorMsg(res.errmsg);
              return;
            }
            successMsg('修改成功');
            this.dialog_rename_visible = false;
            this.current_node.data.name = newFileName;
            this.current_node.data.path = new_path;
            console.log('newFileName', newFileName);
            this.$Bus.$emit('changeArticleInfo', { title: newFileName });
          });
        });
      },
      /**
       * 关闭新建弹框
       */
      dialogCreateClose() {
        this.dialog_create_new = false;
        this.create_new_info =
          {
            dir_name: '',
            article_name: ''
          };
      },
      handleOpenDialog() {
        const html = document.getElementsByTagName('html')[0];
        html.setAttribute('style', 'height: auto; overflow: hidden');
      },
      handleCloseDialog() {
        // 确保每次在关闭弹窗的时候，清除掉错误提示
        // 避免打开新建或者重命名弹窗时候，带有上一次的输入错误提示
        this.$refs.renameForm && this.$refs.renameForm.clearValidate();
        this.$refs.createInfoForm && this.$refs.createInfoForm.clearValidate();
        const html = document.getElementsByTagName('html')[0];
        html.setAttribute('style', 'height: auto');
      },
      /**
       * 创建文章
       */
      handleCreate() {
        this.$refs.createInfoForm.validate((valid) => {
          if (!valid) {
            return focus1stError;
          }
          const defaultExtensions = '.md';
          const { path } = this.contextMenuData;
          // 相对路径拼接，后端负责 normalize
          const extensions = defaultExtensions;
          let newPath = !path ? './' : `${path}/`;
          if (!this.create_new_info.article_name) {
            errorMsg('温馨提示：新建文件夹之后需要至少新建一个笔记，此文件夹才会同步到服务器！');
            return;
          }
          if (this.create_new_info.dir_name) {
            newPath = `${newPath}${this.create_new_info.dir_name}/`;
          }
          newPath += `${this.create_new_info.article_name}${extensions}`;
          createArticle2(newPath, '').then(res => {
            let aid = res.data.aid;
            this.$router.push({
              name: 'editor-id',
              params: { id: aid }
            });
          });
        });
      },
      // 允许拖拽判断
      allowDrop(draggingNode, dropNode, type) {
        if (dropNode.data.type === 'file') {
          return type === "prev";
        } else {
          return type === "inner";
        }
      },
      // 拖拽移动
      handleDrop(draggingNode, dropNode, dropType, ev) {
        if (draggingNode.data.type === "file") {
          const oldPath = draggingNode.data.path;
          let oldName = getFileName(oldPath);
          let targetNode;
          if (dropType === 'inner') {
            // dropNode is dir
            targetNode = dropNode;
          } else {
            // 不能用 dropNode.parent === draggingNode.parent 判定，draggingNode.parent 取不到
            if (getDirName(dropNode.data.path) === getDirName(draggingNode.data.path)) {
              // 目录内拖拽
              return;
            }
            targetNode = dropNode.parent;
          }
          const newPath = targetNode.data.path + "/" + oldName;
          renameArticle(draggingNode.data.id, oldPath, newPath).then((res) => {
            if (res.status) {
              draggingNode.data.path = newPath;
            }
          });
        } else {
          const oldPath = draggingNode.data.path;
          let oldName = getFileName(oldPath);
          let targetNode;
          if (dropType === 'inner') {
            // dropNode is dir
            targetNode = dropNode;
          } else {
            // 不能用 dropNode.parent === draggingNode.parent 判定，draggingNode.parent 取不到
            if (getDirName(dropNode.data.path) === getDirName(draggingNode.data.path)) {
              // 目录内拖拽
              return;
            }
            targetNode = dropNode.parent;
          }
          const newPath = targetNode.data.path + "/" + oldName;
          renameDir(oldPath, newPath);
        }
      },
    },
    directives: {
      Clickoutside
    }
  };
</script>

<style lang="stylus">
  .el-tree-wrap {
    .el-tree-node__children {
      overflow visible
    }
    .custom-tree-icon {
      width 0
      padding 0 !important
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: rgba(0, 0, 0, 0.1) !important;
    }
  }
</style>
<style lang="stylus" scoped>
  /* 导入全局样式变量 */
  @import '~assets/stylus/variable.styl'
  .creat-new-form {
    .modal-input {
      width 260px
    }
  }

  .content-wrap {
    height: calc(100% - 40px);
  }

  .mobile-content-wrap {
    height: calc(100% - 70px);
  }

  .tools-icon-wrap {
    display flex
    align-items center
    justify-content space-between
    padding 12px 18px 11px 20px
    border-bottom 1px solid rgba(204, 204, 204, 0.3);
    .other-icon-wrap {
      display flex
      align-items center
      .tools-icon {
        margin-left 18px
        width 16px
        height 16px
        cursor pointer
      }
      .tools-icon:first-of-type {
        margin-left 0
      }
    }
    .sync-wrap {
      position relative
      .ion-android-refresh {
        font-size 16px
        cursor pointer
      }
    }
    .sync-wrap::before {
      content ""
      position absolute
      left 0
      top 0
      height 16px
      background-color #DDDDDD
      width 1px
    }
  }

  .el-tree-wrap {
    overflow-x: scroll;
    height: 100%;
    padding-top: 10px;
    padding-left 10px;
    .el-tree {
      min-width: 100%;
      display: inline-block;
    }
    .pointer {
      cursor: pointer;
    }
    .custom-tree-node {
      display flex
      position relative;
      color #333;
      font-size 14px;
      width 100%;
      height: 100%;
      align-items center;
      .custom-tree-node_label-wrap {
        margin-left 5px
      }
      .custom-tree-icon {
        cursor pointer
      }
      .dir {
        background: url("~assets/img/Folder-open.png");
        padding-left 15px
        height 13px
        display inline-block
        background-size cover
      }
      .dir-off {
        background: url("~assets/img/Folder-close.png");
      }
      .file {
        background: url("~assets/img/Article.png");
        padding-left 15px
        height 13px
        display inline-block
        background-size cover
      }
      .file-on {
        background: url("~assets/img/article-on.png");
      }
    }
  }

  .struct-flat-wrap {
    .file {
      background: url("~assets/img/Article.png");
      padding-left 15px
      height 13px
      display inline-block
      background-size cover
    }
    .file-on {
      background: url("~assets/img/article-on.png");
    }
    .struct-flat-item {
      position relative
      display table-row
      min-width 100%
      white-space: nowrap;
      cursor pointer
      padding-left 5px
      height 27px
      .file-icon-title-wrap {
        display flex
        align-items center
      }
      .struct-flat-item_label-wrap {
        margin-left 5px
        display inline-block
        height 27px
        line-height 27px
      }
      &:hover {
        background border_color_lv3
      }
    }
  }

  .tree {
    ul {
      padding-left 15px
      li {
        &::before, &::after {
          content ''
          left -5px
          position absolute
          right auto
        }
        &::after {
          border-top 1px dashed base_color
          top 25px
          width 8px
        }
        &::before {
          border-left: 1px dashed base_color
          bottom 50px
          height 100%
          top 0
          width 1px
        }
        &:last-child::before {
          height 26px
        }
      }
    }
    li {
      list-style-type none
      margin 0
      padding 15px 0 0 5px
      position relative
    }
    .node-name {
      display flex
      align-items center
      white-space: nowrap;
    }
    .dir {
      background: url("~assets/img/Folder-open.png");
      padding-left 15px
      height 13px
      display inline-block
      background-size cover
    }
    .dir-off {
      background: url("~assets/img/Folder-close.png");
    }
    .name-text {
      display inline-block
      font-size 14px
      padding-left 10px
      width 100%
      white-space: nowrap;
      a {
        cursor pointer
        display inline-block
      }
    }
    .file {
      background: url("~assets/img/Article.png");
      padding-left 15px
      height 13px
      display inline-block
      background-size cover
    }
    .file-on {
      background: url("~assets/img/article-on.png");
    }
  }

  .hidden-child {
    ul {
      display none
    }
  }

  .contextmenu {
    z-index 9999999
    display inline-block
    position fixed
    background white
    border-radius 5px

    li {
      width 100px
      list-style none
      border 1px solid border_color_lv3
      border-bottom none
      cursor pointer
      padding 0 10px
      line-height 30px

      &:hover {
        background border_color_lv3
      }

      &:last-child {
        border-bottom 1px solid border_color_lv3
      }
    }
  }

  .contextmenu ul li:before, .contextmenu ul li:after {
    display none
  }

  .contextmenu ul, .contextmenu /deep/ .el-button {
    padding 0
  }

  /deep/ .el-button--text {
    color normal_text_color
  }

  .rename-row {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    label {
      padding-right: 20px;
    }
    input {
      flex: 1;
      padding: 0 15px;
      height: 40px;
      line-height: 40px;
      outline: none;
      border-radius: 4px;
      border: 1px solid border_color_lv3;
    }
    .readonly {
      background: border_color_lv3;
    }
  }

  .submit-btn {
    outline: none;
    padding: 5px 10px;
    border: 1px solid base_color;
    margin-top: 10px;
    color: base_color;
  }

  /deep/ .el-dialog {
    z-index: 99999 !important;
  }

  .contextmenu-btn {
    width: 100%;
  }

  .node-name .hover-menu {
    opacity: 0;
  }

  .node-name:hover .hover-menu {
    opacity: 100;
  }

  .hover-btn-wrap {
    position relative
    display flex
    width 200px
    height 35px
    border 1px solid rgba(0, 0, 0, .1)
    border-radius 8px
    background-color #FFFFFF
    align-items center
    justify-content center
  }

  .hover-btn {
    display flex
    border: none;
    outline: none;
    cursor: pointer;
    padding: 2px 3px;
    border-radius: 2px;
    font-size 12px;
    align-items center
    justify-items center
    &:hover {
      background: occupy_text_color;
    }
    i {
      width: 13px;
      height: 13px;
      display: inline-block;
      margin-right 5px
      margin-top -3px
    }
  }

  .hover-btn-edit {
    background: url("~assets/img/take_edit.png");
  }

  .hover-btn-rename {
    background: url("~assets/img/take_rename.png");
  }

  .hover-btn-delete {
    background: url("~assets/img/take_del.png");
  }
</style>
